







































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import {
  requestApproveNewMember,
  requestGettingContact,
  requestCommunication
} from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import approveNewMemberPdfMaker from '@/helpers/pdfmakers/approveNewMember';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;
const FORMAT_DATE_TIME = formatData.dateTime;

const test2Rows = [
  {
    id: 0,
    title: 'Add a new function to your menu that allows to upload legal documents and…',
    date: '15/09/2018'
  },
  {
    id: 1,
    title: 'Possibility to delete an order from the market place.',
    date: '17/12/2018'
  }
];

@Component({
  components: {
    SidebarRight,
    titlePageComponent,
    tableComponent,
    PulseLoader
  }
})
export default class Permission extends Base {
  btnText = 'Get in contact';
  waitingsTable = {
    titleText: 'LIST OF WAITING MEMBERS',
    titleBg: 'pink-green-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'name', title: 'FULL NAME' },
      { field: 'email', title: 'EMAIL' },
      { field: 'address', title: 'WALLET ADDRESS' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  newFeaturesTable = {
    titleText: 'COMMUNICATION',
    titleBg: 'green-blue-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'title', title: 'DESCRIPTION' },
      { field: 'date', title: 'DATE' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  approveMemberTables: any = {
    titleText: 'APPROVE MEMBERS',
    titleBg: 'pink-green-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'creator', title: 'NAME' },
      { field: 'date', title: 'DATE' },
      { field: 'by', title: 'BY' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  communicationsTables: any = {
    titleText: 'COMMUNICATIONS',
    titleBg: 'green-blue-title',
    sorted: 'counter',
    columns: [
      { field: 'counter', title: '#' },
      { field: 'message', title: 'MESSAGE' },
      { field: 'from', title: 'FROM' },
      { field: 'date', title: 'DATE' }
      ],
    rows: []
  };

  // Computed
  get isAgent() {
    return this.isReader;
  }
  get waitingsData() {
    Vue.set(this.waitingsTable, 'rows', Object.values(this.getWaitings));
    return this.waitingsTable;
  }
  get approveMemberData() {
    let rows: any[] = [];
    for (let variable in this.getMembers) {
      let row: any = {};
      let member = this.getMembers[variable];
      let approver = this.getMembers[member.approver];
      row.creator = member.name;
      row.by = approver ? approver.name : '';
      row.id = member.id;
      row.address = member.address;
      row.value = formatData.number(member.creationTime);
      row.date = this.$moment.unix(member.creationTime).format(FORMAT_DATE);
      row.action = this.downloadApproveMember;
      rows.push(row);
    }
    Vue.set(this.approveMemberTables, 'rows', rows);
    return this.approveMemberTables;
  }
  get communicationsData() {
    return this.communicationsTables;
  }

  mounted() {
    if (!this.isAgent) {
      this.communicationsTables.columns.push({ field: 'action', title: 'ACTION' });
    }
    this.getCommunicationsData();
  }

  // Methods
  requestNewFeature(data, isReply = false) {
    this.setSideBarForm(requestGettingContact(data, isReply));
    this.openClose();
  }
  requestCommunication() {
    this.setSideBarForm(requestCommunication((result, err) => {
      if (result) {
        const row: any = this.buildCommunicationRow(result, this.communicationsTables.rows.length + 1);
        this.communicationsTables.rows.push(row);
      }
      if (err) {
        this.$toasted.error(err.error);
      }
    }));
    this.openClose();
  }
  approveNewMember({ address, id }) {
    const waiting = this.getWaitings[address];
    this.setSideBarForm(requestApproveNewMember(waiting, id));
    this.openClose();
  }
  downloadApproveMember(addr) {
    const filename = this.getTokenInfo.symbol + '_approve_member';
    const approveDate = this.$moment.unix(this.getMember(addr).creationTime).format(FORMAT_DATE);
    approveNewMemberPdfMaker(
      addr,
      approveDate,
      this.getMember,
      this.getOwners
    ).download(filename);
  }
  getCommunicationsData() {
    this.communications
      .get()
      .then(res => {
        const rows: any[] = [];
        let counter = 1;
        for (let key in res) {
          const row = this.buildCommunicationRow(res[key], counter);
          counter++;
          rows.push(row);
        }
        this.communicationsTables.rows = rows;
      })
      .catch(err => {
        this.$toasted.error(err.error.message);
      });
  }
  isApprovedMemberPending({ id }) {
    return this.getPendings.newMemberApprove.id === id;
  }

  isSomeMemberPending() {
    return this.getPendings.newMemberApprove.id;
  }

  buildCommunicationRow(data, counter) {
    let row: any = {};
    const item = data;
    row.counter = counter;
    row.from = item.person_id === 1 ? 'Agent' : 'Support Team';
    row.date = this.$moment(item.updated_at).format(FORMAT_DATE_TIME);
    row.message = item.message_text;
    row.origin = item;
    return row;
  }
};
